import React from "react";
import Flagship from "../../core/flagship";
import SingleRecordField from "./SingleRecordField";

import { empty, renderFieldValue, shouldShowField } from "../../utils/helpers";
import {
  Table,
  Loader,
  Label,
  Grid,
  Divider,
  Header,
  Icon,
  Button,
} from "semantic-ui-react";
import LineItemBox from "../misc/LineItemBox";
import IoProductBox from "../misc/IoProductBox";
import Attachments from "./Attachments";


class SingleRecordView extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
    this.renderLineItems = this.renderLineItems.bind(this);
    this.getAdvisrClientName = this.getAdvisrClientName.bind(this);
  }

  getInitialState() {
    return (
      {
        advisrClientName:null
      }
    );
  }

  componentDidMount() {
    this.getAdvisrClientName();
  }

   componentDidUpdate(props) {

    if (props.recordData.record.id === this.props.recordData.record.id) {
      return;
    } else {
      this.getAdvisrClientName(true);
    }
   }

  getAdvisrClientName(shouldResetState=false) {

    if (this.props.route.type === "client" && this.props.recordData.record.extra4) {
      // Get Advisr client name and set into state


      const self = this;

      Flagship.get(
            `advisr-client/${this.props.recordData.record.extra4}`,
            {},
            function (response) {
              if (response.data.success === true) {
                self.setState({advisrClientName: response.data.client});
                
              } else {
                Flagship.error(
                  "Could not retrieve Advisr client name by ID",
                );
              }
            },
            function (err) {
              console.error(err);
              Flagship.error("An error occurred retrieving client name: " + err, 0, 0);
            }
          );
    } else if (shouldResetState) {
      this.setState(this.getInitialState());
    }
  }

  renderLineItems() {
 
    const {props} = this;
        
    return (
      <div>
        {props.route.type === "rfp" && props.hideLineItems !== true ? (
          <LineItemBox
            key={"rfp-line-items-" + props.recordData.record.id}
            recordId={props.recordData.record.id}
            recordKey={props.recordData.record.record_key}
            recordStatus={props.recordData.record.record_status}
            recordType={props.route.type}
            onAddLineItem={props.onAddLineItem}
            onStatusChange={props.getRecordData}
            viewingChild={props.viewingChild}
            onCloseModals={props.onCloseModals}
            updateLineItems={props.updateLineItems}
            onChangeAssignee={props.getRecordData}
            parentMode={props.route.mode}
            record={props.recordData.record}
          />
        ) : null}

        {props.route.type === "io" && props.hideLineItems !== true ? (
          <IoProductBox
            key={"io-products-" + props.recordData.record.id}
            market={props.recordData.record.market}
            client={props.recordData.record.extra4.name}
            tier={props.fieldData[444]}
            recordId={props.recordData.record.id}
            recordKey={props.recordData.record.record_key}
            recordStatus={props.recordData.record.record_status}
            recordType={props.route.type}
            onAddIoProduct={props.onAddLineItem}
            onStatusChange={props.getRecordData}
            viewingChild={props.viewingChild}
            onCloseModals={props.onCloseModals}
            updateLineItems={props.updateLineItems}
            onChangeAssignee={props.getRecordData}
            parentMode={props.route.mode}
            isAdvisr={props.isAdvisr}
          />
        ) : null}
      </div>
    );
  }

  render() {

  const {props} = this;

  if (typeof props.recordData === "undefined") {
    return (
      <Table>
        <Table.Body>
          <Table.Row>
            <Table.Cell colSpan="5">
              <Loader className="flagship-loader" active inline="centered">
                Loading...
              </Loader>
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  } else {
    let readOnly = props.readOnly;

    if (!empty(props.recordData.record)) {
      return (
        <Grid stackable>
          <Grid.Column
            mobile={16}
            tablet={8}
            computer={10}
            largeScreen={10}
            widescreen={10}
            width={6}
            style={{ marginTop: "1.5em" }}
          >
            {props.recordData.record.record_type === "io" ||
            props.recordData.record.record_type === "rfp" ? (
              <div key="record-key" className="single-record-single-field">
                <Label>
                  {props.recordData.record.record_type.toUpperCase()} Number
                </Label>
                <div className="field-value">
                  #{props.recordData.record.record_key}
                </div>
              </div>
            ) : null}

            {!empty(
              Flagship.config.records[props.recordData.record.record_type]
                .extra1
            ) && !empty(props.recordData.record.extra1) ? (
              <div key="record-extra1" className="single-record-single-field">
                <Label>
                  {
                    Flagship.config.records[props.recordData.record.record_type]
                      .extra1.label
                  }
                </Label>
                <div className="field-value">
                  {props.route.type === "io" && props.isAdvisr === true ? (
                    <div>Advisr Proposal</div>
                  ) : (
                    renderFieldValue(
                      props.recordData.record.extra1,
                      props.route.type !== "io" || props.userRole !== "ae"
                        ? Flagship.config.records[
                            props.recordData.record.record_type
                          ].extra1.validation
                        : "unlinked-rfp"
                    )
                  )}
                </div>
              </div>
            ) : null}

            {!empty(
              Flagship.config.records[props.recordData.record.record_type]
                .extra4
            ) && !empty(props.recordData.record.extra4) ? (
              <div key="record-extra4" className="single-record-single-field">
                <Label>
                  {
                    Flagship.config.records[props.recordData.record.record_type]
                      .extra4.label
                  }
                </Label>
                <div className="field-value">
                  {renderFieldValue(
                    props.recordData.record.extra4,
                    Flagship.config.records[props.recordData.record.record_type]
                      .extra4.validation
                  )}
                  {this.state.advisrClientName ? ` (${this.state.advisrClientName})`: null}
                </div>
              </div>
            ) : null}

            {props.instance !== "SHIFT" ||
            props.recordData.record.record_type !== "client" ? (
              !empty(
                Flagship.config.records[props.recordData.record.record_type]
                  .extra2
              ) && !empty(props.recordData.record.extra2) ? (
                <div key="record-extra2" className="single-record-single-field">
                  <Label>
                    {
                      Flagship.config.records[
                        props.recordData.record.record_type
                      ].extra2.label
                    }
                  </Label>
                  <div className="field-value">
                    {renderFieldValue(
                      props.recordData.record.extra2,
                      Flagship.config.records[
                        props.recordData.record.record_type
                      ].extra2.validation
                    )}
                  </div>
                </div>
              ) : null
            ) : null}

            {!empty(
              Flagship.config.records[props.recordData.record.record_type]
                .extra3
            ) && !empty(props.recordData.record.extra3) ? (
              <div key="record-extra3" className="single-record-single-field">
                <Label>
                  {
                    Flagship.config.records[props.recordData.record.record_type]
                      .extra3.label
                  }
                </Label>
                <div className="field-value">
                  {renderFieldValue(
                    props.recordData.record.extra3,
                    Flagship.config.records[props.recordData.record.record_type]
                      .extra3.validation
                  )}
                </div>
              </div>
            ) : null}

            {props.recordFields.map(function (item, i) {
              return shouldShowField(item, props.fieldData) ? (
                <SingleRecordField
                  recordId={props.recordData.record.id}
                  afterSave={props.getRecordData}
                  readOnly={readOnly}
                  key={"field-" + i}
                  {...item}
                />
              ) : null;
            })}

            {this.renderLineItems()}
          </Grid.Column>
          <Grid.Column
            mobile={16}
            tablet={8}
            computer={6}
            largeScreen={6}
            widescreen={6}
            width={6}
          >
            {props.recordData.record.record_status === "trash" ? (
              <div>
                <Divider hidden />
                <Header as="h3">
                  <Icon size="mini" name="warning sign" color="red" />
                  Canceled {props.route.niceName}
                </Header>
                <Divider />
                <p>This {props.route.niceName} is canceled.</p>
                {readOnly !== true ? (
                  <Button
                    icon="undo"
                    content={"Reactivate " + props.route.niceName}
                    onClick={props.onReactivateRecord}
                  />
                ) : null}
              </div>
            ) : props.recordData.record.record_type !== "rfp" ||
              props.recordData.record.record_status !== "draft" ? (
              <Attachments
                recordId={props.recordData.record.id}
                recordType={props.recordData.record.record_type}
                recordStatus={props.recordData.record.record_status}
                recordName={props.recordData.record.record_name}
                recordKey={props.recordData.record.record_key}
                recordMarket={props.recordData.record.market}
                userId={props.userId}
                onStatusChange={props.onStatusChange}
                parent={props.recordData.record.parent}
                businessClosed={props.recordData.record.closed}
                onCancelRecord={props.onCancelRecord}
                hasContract={props.hasContract}
                hasAdvisrIo={props.hasAdvisrIo}
                niceName={props.route.niceName}
                isAdvisr={props.isAdvisr}
              />
            ) : null}
          </Grid.Column>
        </Grid>
      );
    } else {
      return <div>Nothing found.</div>;
    }
  }
  }

}

export default SingleRecordView;



// WEBPACK FOOTER //
// ./src/components/misc/SingleRecordView.js